import { breadcrumb } from './breadcrumb';

export const referral = {
  breadcrumb,

  description:
    'Вы можете получать бонусы за приведенных вами клиентов. За каждого нового пользователя, который зарегистрировался по вашей ссылке, вы будете получать до {percent}% от его расходов.',

  button: {
    create_request: 'Вывод средств'
  },

  user: {
    field: {
      email: 'Email',
      created_at: 'Дата регистрация'
    }
  },

  profit: {
    field: {
      date_from: 'Начало периода',
      date_to: 'Конец периода',
      referral: 'Реферал',
      amount: 'Сумма'
    }
  },

  request: {
    type: {
      internal: 'Баланс Zorra',
      external: 'Вывод средств'
    },

    status: {
      pending: 'Проверка',
      success: 'Выполнен',
      rejected: 'Отклонен',
      failed: 'Ошибка'
    },

    field: {
      amount: 'Сумма'
    },

    modal: {
      create: {
        content:
          'Ваш баланс {balance}. Вы можете пополнить баланс Zorra или создать заявку на вывод денег'
      }
    }
  }
};
